// Blog hero - v2 cinematic liquid-glass layout ported from hero-v2.jsx
import Reveal from "../components/Reveal";
import { useVideoFade } from "../lib/useVideoFade";
import { VIDEOS, POSTERS } from "../lib/media";

export default function BlogHero() {
  const videoRef = useVideoFade();

  return (
    <section className="min-h-screen bg-black overflow-hidden relative flex flex-col">
      {/* Instant still frame; the playing video fades in over it once loaded */}
      <img
        src={POSTERS.blogHero}
        alt=""
        aria-hidden="true"
        className="hero-media hero-media--blog hero-media--poster"
      />
      <video
        ref={videoRef}
        className="hero-media hero-media--blog"
        src={VIDEOS.blogHero}
        autoPlay
        muted
        playsInline
        preload="auto"
        style={{ opacity: 0 }}
      />
      <div className="vignette" aria-hidden="true" />

      {/* Hero content */}
      <main className="relative z-10 flex-1 flex flex-col items-center justify-center px-6 py-12 text-center -translate-y-[20%]">
        <Reveal>
          <h1
            className="font-instrument text-6xl md:text-8xl lg:text-9xl text-white mb-8 tracking-tight whitespace-nowrap"
            style={{ lineHeight: 0.95 }}
          >
            Built for the curious
          </h1>
        </Reveal>

        <div className="max-w-xl w-full space-y-4">
          <Reveal delay={200}>
            <p className="text-white/70 text-sm leading-relaxed px-4">
              Field notes, sector deep-dives and product thinking from the Paisums team.
            </p>
          </Reveal>

          <Reveal delay={280}>
            <div className="pt-2 flex justify-center">
              <a
                href="/manifesto.html"
                className="liquid-glass rounded-full px-8 py-3 text-white text-sm font-medium hover:bg-white/5 transition-colors"
              >
                Read the manifesto
              </a>
            </div>
          </Reveal>
        </div>
      </main>

    </section>
  );
}
